<h3 mat-dialog-title>
    {{ data.title }}
    <button mat-icon-button disableRipple mat-dialog-close><mat-icon>close</mat-icon></button>
</h3>

<ng-template #baseContent>
    <p [innerHTML]="data.content"></p>
    <p *ngIf="data.danger" class="confirmation-warning" [innerHTML]="data.danger"></p>
</ng-template>

<mat-dialog-content>
    <form *ngIf="data.control; else baseContent" [formGroup]="formGroup">
        <ng-container *ngTemplateOutlet="baseContent"></ng-container>
        <div class="form-group">
            <mat-slide-toggle *ngIf="data.control.type === 'toggle'" [formControlName]="data.control.type">
                {{ data.control.label }}
            </mat-slide-toggle>
            <label *ngIf="data.control.type !== 'toggle'">{{ data.control.label }}</label>
            <mat-form-field *ngIf="data.control.type === 'select'" appearance="outline" subscriptSizing="dynamic">
                <mat-select [panelClass]="'v2-panel'" placeholder="{{ 'Select Option' }}" [formControlName]="data.control.type">
                    <mat-option *ngFor="let option of data.control.options"
                                [value]="option">
                        {{ option.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <lf-control-messages [control]="formGroup.get(data.control.type)"></lf-control-messages>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-flat-button disableRipple color="accent"
            [class.hidden]="data.hideCancelButton"
            (click)="closeAndCancel()">
        {{ data.cancelButton || 'Cancel' }}
    </button>

    <button-spacer></button-spacer>

    <button *ngIf="data.secondaryButton"
            mat-flat-button disableRipple color="accent"
            (click)="closeSecondary()">
        {{ data.secondaryButton }}
    </button>
    <button-spacer *ngIf="data.secondaryButton"></button-spacer>

    <button mat-flat-button disableRipple color="primary"
            (click)="closeAndConfirm()">
        {{ confirmButtonLabel }}
    </button>
</mat-dialog-actions>
